// @ts-check

if (!customElements.get("ff-collapsible-tabs")) {
  class FfCollapsibleTabs extends HTMLElement {
    /**
     * @type {"own_close" | "own_expand" | "else" | undefined}
     */
    ffTransition;
    /**
     * @type {undefined | function}
     */
    ffWaitingAction;

    /**
     * @type {{tabTriggerEL: undefined | HTMLElement & {ffOnClick: () => void, ffOnOwnToggle: () => void}, tabContentEL: undefined | HTMLElement}}
     */
    ffActive = {
      tabTriggerEL: undefined,
      tabContentEL: undefined,
    };

    constructor() {
      super();
      this.ffInit();
    }

    ffInit = () => {
      const tabsEL = [];
      /**
       * @type {HTMLElement[]}
       */
      const tabsContentEL = [];
      /**
       * @type {HTMLElement[]}
       */
      const tabsTriggersEL = [];
      // @ts-ignored
      window.ffCollapsibleTabsConfiguration[this.id].forEach(
        ({ triggerSelector, contentSelector, initActive, onOwnToggle }) => {
          const tabTriggerEL = this.querySelector(triggerSelector);
          const tabContentEL = this.querySelector(contentSelector);
          // @ts-ignore
          tabsTriggersEL.push(tabTriggerEL);
          // @ts-ignore
          tabsContentEL.push(tabContentEL);

          tabTriggerEL.ffOnOwnToggle = onOwnToggle;
          if (initActive) {
            this.ffActive = {
              tabTriggerEL,
              tabContentEL,
            };
          }
        }
      );

      tabsEL.push(...tabsContentEL, ...tabsTriggersEL);

      for (let index = 0; tabsTriggersEL.length > index; index++) {
        const tabContentEL = tabsContentEL[index];
        /**
         * @type {HTMLElement & {ffOnClick: () => void, ffOnOwnToggle: () => void}}
         */
        // @ts-ignore
        const tabTriggerEL = tabsTriggersEL[index];

        tabTriggerEL.ffOnClick = () => {
          for (let tabEl of tabsEL) {
            if (tabEl === tabTriggerEL) {
              continue;
            }
            if (tabEl === tabContentEL) {
              continue;
            }
            tabEl.classList.remove("ff-collapsible-tab-active");
          }

          tabTriggerEL.classList.toggle("ff-collapsible-tab-active");
          tabContentEL.classList.toggle("ff-collapsible-tab-active");

          tabTriggerEL.classList.add("ff-collapsible-tab_transitioning");

          if (this.ffActive.tabTriggerEL === tabTriggerEL) {
            this.ffTransition = "own_close";
          } else if (this.ffActive.tabTriggerEL === undefined) {
            this.ffTransition = "own_expand";
          } else {
            this.ffTransition = "else";
          }

          this.ffActive = {
            tabTriggerEL,
            tabContentEL,
          };
        };

        tabTriggerEL.addEventListener("click", (e) => {
          if (this.ffWaitingAction === undefined) {
            switch (this.ffTransition) {
              case "own_close":
                if (this.ffActive.tabTriggerEL != tabTriggerEL) {
                  this.ffWaitingAction = tabTriggerEL.ffOnClick;
                }
                break;
              //when a tab content is in the middle of expanding
              case "own_expand":
                this.ffWaitingAction = () => {
                  // this.ffActive.tabTriggerEL?.ffOnOwnToggle();
                  this.ffActive.tabTriggerEL?.ffOnOwnToggle();
                  this.ffActive.tabTriggerEL?.ffOnClick();
                  if (tabTriggerEL != this.ffActive.tabTriggerEL) {
                    this.ffWaitingAction = () => {
                      tabTriggerEL.ffOnOwnToggle();
                      tabTriggerEL.ffOnClick();
                    };
                  }
                };
                break;

              case "else":
                this.ffWaitingAction = tabTriggerEL.ffOnClick;
                break;

              default:
                if (
                  this.ffActive.tabTriggerEL &&
                  this.ffActive.tabTriggerEL != tabTriggerEL
                ) {
                  this.ffActive.tabTriggerEL.ffOnOwnToggle();
                  this.ffActive.tabTriggerEL.ffOnClick();
                  this.ffWaitingAction = () => {
                    tabTriggerEL.ffOnOwnToggle();
                    tabTriggerEL.ffOnClick();
                  };
                } else {
                  tabTriggerEL.ffOnOwnToggle();
                  tabTriggerEL.ffOnClick();
                }
                break;
            }
          }
        });

        if (
          tabContentEL.classList.contains(
            "ff-collapsible-tab-content-animate-height--js"
          )
        ) {
          const {
            clientHeight: tabContentHeight,
            clientWidth: tabContentWidth,
          } = tabContentEL.children[0];
          tabContentEL.style.setProperty(
            "--ff-expanded-height",
            tabContentHeight + "px"
          );

          tabTriggerEL.style.setProperty(
            "--ff-expanded-width",
            tabContentWidth + "px"
          );

          tabTriggerEL.style.setProperty(
            "--ff-collapsible-tabs-transition-width-seconds",
            tabContentHeight * 0.0006 + 0.1 + "s"
          );

          tabContentEL.style.setProperty(
            "--ff-collapsible-tabs-transition-width-seconds",
            tabContentHeight * 0.0006 + 0.1 + "s"
          );

          tabContentEL.style.setProperty(
            "--ff-collapsible-tabs-transition-seconds",
            tabContentHeight * 0.0004 + 0.06 + "s"
          );
        }

        tabContentEL.addEventListener("transitionend", () => {
          tabTriggerEL.classList.remove("ff-collapsible-tab_transitioning");

          if (this.ffTransition == "own_close") {
            this.ffActive = {
              tabTriggerEL: undefined,
              tabContentEL: undefined,
            };
          }

          if (this.ffWaitingAction) {
            //action has the ability to stablish a waiting action
            const action = this.ffWaitingAction;
            this.ffWaitingAction = undefined;
            requestAnimationFrame(() => {
              action();
            });
          } else {
            this.ffTransition = undefined;
          }
        });
      }
    };
  }

  customElements.define("ff-collapsible-tabs", FfCollapsibleTabs);
}

// @ts-ignore
if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    requestAnimationFrame(() => {
      /**
       * @type {NodeListOf<FfNavigationTabs>}
       */
      const navigators = document.querySelectorAll("ff-collapsible-tabs");
      navigators.forEach((tabs) => {
        tabs.ffInit();
      });
    });
  });
}
